// src/imageUrl.ts
import createImageUrlBuilder from "@sanity/image-url";

import client from "./sanityClient";

const builder = createImageUrlBuilder(client);

export const urlFor = (source: any) => builder.image(source);
